"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_14b118c2{background:" }, { "theme": "white", "defaultValue": "#ffffff" }, { "rawString": ";padding:8px;pointer-events:none}.root_14b118c2.hasMediumDelay_14b118c2{-webkit-animation-delay:300ms;animation-delay:300ms}.content_14b118c2{font-size:12px;color:" }, { "theme": "neutralPrimary", "defaultValue": "#333333" }, { "rawString": ";word-wrap:break-word;overflow-wrap:break-word}.subText_14b118c2{margin:0}\n" }]);
exports.root = "root_14b118c2";
exports.hasMediumDelay = "hasMediumDelay_14b118c2";
exports.content = "content_14b118c2";
exports.subText = "subText_14b118c2";
//# sourceMappingURL=Tooltip.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Tooltip/Tooltip.scss.js
// module id = 272
// module chunks = 0